import common from '@/api/common';
import faeCommon from '@/view/fae/components/faeCommon'
import faeDataHeader from "@/view/schedule/components/faeDataHeader";
import rankCount from "@/view/schedule/components/rankCount";
import rankTime from "@/view/schedule/components/rankTime";
import capsuleChart from "@/view/schedule/components/capsuleChart";
import trendChart from "@/view/schedule/components/trendChart";
import noData from "@/view/schedule/components/noData";
// import Common from "../../../public/js/common";

export default {
    // name: "charts",
    components: {faeCommon, faeDataHeader, rankCount, rankTime, capsuleChart, trendChart, noData},
    data() {
        return {
            searchDate: new Date(),    // 查询时间

            deptId: '', // 当前用户的部门ID
            userid: '',  // 用户id
            userName: '', // 用户名
            userdept: '', // 用户部门
            userLever: '', // 用户级别
            duty: '', // 职务

            countMenuVal: 0, // 默认0  0 本年 1 本月 2 本周
            countDeptVal: 0,
            startDate: '',// 起始日期
            endDate: '',// 结束日期


            trendData: [], // 趋势对象

            deptCountTotal: 0,
            deptTimeTotal: 0,
            personCountDatas: [], // 个人预约总量排名
            personTimeDatas: [], // 个人预约时间排名
            deptCountDatas: [], // 部门预约量排名
            deptTimeDatas: [], // 部门预约时间排名
            p2pDatas: [], // FAE资源使用情况（P2P）
            p2dDatas: [], // FAE资源使用情况（P2D）
            d2dDatas: [], // FAE资源使用情况（D2D）


            p2pMenuVal: 0,
            p2pMenuOption: [],  // 部门人员
            p2pcapsuleData: [],
            p2pIndex: 6,


            p2dcapsuleData: [],
            p2dIndex: 0,

            d2doption: {},

            prolineCountDatas: [],
            segmentCountDatas: [],
            cusmentCountDatas: [],


            isShow: false,  // 是否有权限看
            isFAE: 0,  // FAE人员（职务类型是技术支持序列 或 FAE分工表中）
            isM: 0,    // 管理者 （M级）
            isBoss: 0,   // 可看全部数据

            isShowUser: false,  // 显示个人
        }
    },
    computed: {
        // wheight() {
        //     let h = document.body.clientHeight || document.body.clientHeight || document.documentElement.clientHeight;
        //     if (h) {
        //         return h
        //     } else {
        //         return 400
        //     }
        // },

    },
    created() {
        this.caleAuthority()
        this.startDate = this.calcStartEndDate(this.countMenuVal, 's');
        this.endDate = this.calcStartEndDate(this.countMenuVal, 'e')

        const {getTotalqty, getPersonCount, getPersonTime, getDeptCount, getDeptTime, getP2P, getP2D, getD2D, getProductLine, getSegment, getCusment} = this;
        if (this.isFAE) {
            getTotalqty()
            getPersonCount()
            getPersonTime()
            getP2P()
            getP2D()
            return
        }
        if (this.isM || this.isBoss) {
            getTotalqty()
            getPersonCount()
            getPersonTime()
            getDeptCount()
            getDeptTime()
            getP2P()
            getP2D()
            getD2D()
            getProductLine()
            getSegment()
            getCusment()
            return
        }
    },
    methods: {
        caleAuthority() {
            let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'))
            this.deptId = ADMIN.USER_DEPARTMENT_ID;
            this.userName = ADMIN.USER_NAME;
            this.userdept = ADMIN.USER_DEPARTMENT_NAME;
            this.userLever = ADMIN.USER_LEVEL_NAME;
            this.duty = ADMIN.DUTY_NAME;

            // 测试用
            // this.deptId = 985;
            // this.userName =  "刘迅";
            // this.userdept = "中电港";
            // this.userLever = "M5";
            // this.duty = '总经理';

            this.bosArrName = JSON.parse(localStorage.getItem('BOSS_NAME')) || [];
            let userName = JSON.parse(localStorage.getItem('LS_ADMIN')).USER_ACCOUNT; // 当前用户 英文名
            let dutyName = JSON.parse(localStorage.getItem('LS_ADMIN')).DUTY_NAME; // 当前用户 职位
            this.isBoss = this.bosArrName.includes(userName) || this.bosArrName.includes(dutyName);



            if (this.isBoss) {
                this.deptId = 985;
                this.deptName = "中电港";
                this.userdept = "中电港";
                this.countDeptVal = this.deptId;
                this.isShow = true;
                return
            }

            // alert(this.isBoss + ' ' + this.bosArrName);

            if (this.duty == '总经理') {
                this.isFAE = 0;
                this.isM = 0;
            }
            if (this.userLever.substring(0, 1) == 'M') {
                this.isFAE = 0;
                this.isM = 1;
            }
            if (this.userLever.substring(0, 1) == 'P' && this.duty == '资深FAE') {
                this.isFAE = 1;
                this.isM = 0;
            }

            // 是否有权限看
            if (this.isM || this.isFAE) {
                this.isShow = true
            } else {
                this.isShow = false
            }
        },
        // 根据部门获取部门人员名单
        /* getDeptPerson() {
             let entityId = this.CoreNew.SYSTABLE.USER
             let params = {DEPARTMENT_ID: this.deptId}
             common.generalConditionQuery(entityId, params).then(res => {
                 if (res && res.flag && Array.isArray(res.data)) {
                     if (res.data.length > 0) {
                         this.p2pMenuOption = this.formatMenu(res.data);
                         // this.p2dIndex = this.p2pMenuOption[0].value;
                         // console.log(this.p2pMenuOption)
                         // console.log(this.p2dIndex)
                     }
                 } else {
                     this.$toast("网络异常，请稍后再试！");
                 }
             })
         },*/
        formatMenu(arr) {
            if (!arr || arr.length == 0) {
                return
            }
            // p2pMenuOption: [
            //   {text: '产品二部', value: 0},
            //   {text: '产品一部', value: 1}
            // ],

            let temArr = arr.map((item, index) => {
                let temObj = {}
                temObj.value = index;
                temObj.text = item.LABEL_NAME
                temObj.id = Number(item.CODE);
                return temObj
            })
            return temArr;
        },

        // 根据 NAME 汇总数据
        classifyArrByName(arr) {
            let map = {}, dest = [];
            for (let i = 0; i < arr.length; i++) {
                let ai = arr[i];
                if (!map[ai.NAME]) {
                    dest.push({
                        NAME: ai.NAME,
                        data: [ai]
                    });
                    map[ai.NAME] = ai;
                } else {
                    for (let j = 0; j < dest.length; j++) {
                        let dj = dest[j];
                        if (dj.NAME == ai.NAME) {
                            // dj.data.push(ai);
                            dj.data.unshift(ai);
                            break;
                        }
                    }
                }
            }
            // console.log(dest)
            return dest
        },

        // 根据 DEPT_NAME 汇总数据
        classifyArrByDept(arr) {
            let map = {}, dest = [];
            for (let i = 0; i < arr.length; i++) {
                let ai = arr[i];
                if (!map[ai.DEPT_NAME]) {
                    dest.push({
                        DEPT_NAME: ai.DEPT_NAME,
                        data: [ai]
                    });
                    map[ai.DEPT_NAME] = ai;
                } else {
                    for (let j = 0; j < dest.length; j++) {
                        let dj = dest[j];
                        if (dj.DEPT_NAME == ai.DEPT_NAME) {
                            // dj.data.push(ai);
                            dj.data.unshift(ai);
                            break;
                        }
                    }
                }
            }
            return dest
        },

        /**
         * 计算开始日期 结束日期
         * val
         * type ‘s’开始  ’e‘结束
         * 格式 2020-08-24
         */
        calcStartEndDate(val, type) {
            // let currentDate = new Date();
            let resultDate = '';
            if (val == 0) {
                // 今年
                resultDate = this.Common.getYearday(this.searchDate, type)
            } else if (val == 1) {
                // 本月
                resultDate = this.Common.getMonday(this.searchDate, type)
            } else if (val == 2) {
                // 最近六周
                resultDate = this.Common.getLastWeeks(this.searchDate, 6, type)
            } else if (val == 3) {
                // 本周
                resultDate = this.Common.getWeekday(this.searchDate, type)
            } else if (val == 4) {
                // 上周
                resultDate = this.Common.getLastWeekday(this.searchDate, type)
            }
            return resultDate
        },

        // FAE预约量汇总
        getTotalqty() {
            // 0 本年 1 本月 2 本周
            // year - 本年度  month - 本月 week - 前六周 week_current - 本周 week_last - 上周
            // console.log(this.countMenuVal)
            // if (this.countMenuVal == 1) {
            //   return
            // }

            let pkg = "crm_fae_public_pkg",
                pro = "p_get_totalqty_by_dept",
                type = "COUNT",
                subtype = "",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate,
                countdate = this.startDate,
                counttype = 'year';

            if (this.countMenuVal == 0) {
                counttype = 'year'
            } else if (this.countMenuVal == 1) {
                counttype = 'month'
            } else if (this.countMenuVal == 2) {
                counttype = 'week'
            } else if (this.countMenuVal == 3) {
                counttype = 'week_current'
            } else if (this.countMenuVal == 4) {
                counttype = 'week_last'
            }

            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate,
                COUNT_DATE: countdate,
                COUNT_TYPE: counttype
            };
            this.trendData = []
            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        this.trendData = res.data;
                    }
                } else {
                    this.trendData = []
                }
            })
        },


        // 个人预约总量排名 月
        getPersonCount() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_top_by_dept",
                type = "PERSON",
                subtype = "COUNT",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;

            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };

            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        this.personCountDatas = res.data;
                        this.deptCountTotal = this.caleCount(res.data)
                    } else {
                        this.personCountDatas = []
                        this.deptCountTotal = 0
                    }
                } else {
                    this.personCountDatas = []
                    this.deptCountTotal = 0
                }
            })
        },
        //个人预约时间排名
        getPersonTime() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_top_by_dept",
                type = "PERSON",
                subtype = "TIME",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;

            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };

            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data) && res.data.length > 0) {
                    this.personTimeDatas = res.data;
                    this.deptTimeTotal = parseFloat(this.Common.formatNumber(this.caleTime(res.data), 2, 0))
                } else {
                    this.personTimeDatas = []
                    this.deptTimeTotal = 0
                }
            })
        },
        // 部门预约量排名
        getDeptCount() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_top_by_dept",
                type = "DEPT",
                subtype = "COUNT",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;

            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            common.procedureQuery(params).then(res => {
                if (res && res.flag) {
                    this.deptCountDatas = res.data;
                } else {
                    this.deptCountDatas = [];
                }
            })
        },
        // 部门预约时间排名
        getDeptTime() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_top_by_dept",
                type = "DEPT",
                subtype = "TIME",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;

            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            common.procedureQuery(params).then(res => {
                if (res && res.flag) {
                    this.deptTimeDatas = res.data;
                } else {
                    this.deptTimeDatas = [];
                }
            })
        },
        // FAE资源使用情况（P2P）
        getP2P() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_qty_by_dept",
                type = "P2P",
                subtype = "",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;

            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            this.p2dDatas = []
            this.p2pcapsuleData = []

            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        this.p2pDatas = res.data;
                        this.p2pcapsuleData = this.classifyArrByName(res.data)
                    }

                } else {
                    this.p2pDatas = [];
                    this.p2pcapsuleData = [];
                }
            })
        },
        // FAE资源使用情况（P2D）
        getP2D() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_qty_by_dept",
                type = "P2D",
                subtype = "",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;

            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            this.p2dDatas = []
            this.p2dcapsuleData = []
            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        this.p2dDatas = res.data;
                        this.p2dcapsuleData = this.classifyArrByName(res.data)
                    }
                } else {
                    this.p2dDatas = [];
                    this.p2dcapsuleData = [];
                }
            })
        },

        // FAE资源使用情况（P2P） 个人
        getP2PSinge() {
            // {"pkg":"crm_fae_public_pkg","pro":"p_get_qty_by_dept","TYPE":"P2P","USER_ID":"1113","START_DATE":"2020-09-15","END_DATE":"2020-09-24"}
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_qty_by_dept",
                type = "P2P",
                userid = this.userid,
                startDate = this.startDate,
                endDate = this.endDate;

            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                USER_ID: userid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            this.p2dDatas = []
            this.p2pcapsuleData = []

            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        this.p2pDatas = res.data;
                        this.p2pcapsuleData = this.classifyArrByName(res.data)
                    }

                } else {
                    this.p2pDatas = [];
                    this.p2pcapsuleData = []
                }
            })
        },
        // FAE资源使用情况（P2D） 个人
        getP2DSinge() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_qty_by_dept",
                type = "P2P",
                userid = this.userid,
                startDate = this.startDate,
                endDate = this.endDate;

            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                USER_ID: userid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            this.p2dDatas = []
            this.p2dcapsuleData = []
            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        this.p2dDatas = res.data;
                        this.p2dcapsuleData = this.classifyArrByName(res.data)
                    }
                } else {
                    this.p2dDatas = []
                    this.p2dcapsuleData = []
                }
            })
        },
        // FAE资源使用情况（D2D）
        getD2D() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_qty_by_dept",
                type = "D2D",
                subtype = "",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;
            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            this.d2dDatas = []
            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        this.d2dDatas = res.data;
                        this.d2doption = this.createD2DData(this.formatD2DData(res.data), '{name} {percent}次')
                    }
                } else {
                    this.d2dDatas = []
                    this.d2doption = []
                }
            })
        },

        cutTop(arr) {
            let newArr = arr.slice(0);
            newArr.shift()
            return newArr
        },

        // 产品线 的统计
        getProductLine() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_top_by_dept",
                type = "PRODUCT_LINE",
                subtype = "COUNT",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;
            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            this.prolineCountDatas = []
            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        if (res.data[0].LABEL_NAME) {
                            this.prolineCountDatas = res.data;
                        } else {
                            this.prolineCountDatas = this.cutTop(res.data)
                        }

                    }
                } else {
                    this.prolineCountDatas = []
                }
            })
        },

        // 领域 的统计
        getSegment() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_top_by_dept",
                type = "SEGMENT",
                subtype = "COUNT",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;
            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            this.segmentCountDatas = []
            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        if (res.data[0].SEGMENT) {
                            this.segmentCountDatas = res.data;
                        } else {
                            this.segmentCountDatas = this.cutTop(res.data);
                        }
                    }
                } else {
                    this.segmentCountDatas = []
                }
            })
        },
        // 客户 的统计
        getCusment() {
            let pkg = "crm_fae_public_pkg",
                pro = "p_get_top_by_dept",
                type = "CUST",
                subtype = "COUNT",
                deptid = this.deptId,
                startDate = this.startDate,
                endDate = this.endDate;
            let params = {
                pkg: pkg,
                pro: pro,
                TYPE: type,
                SUB_TYPE: subtype,
                DEPT_ID: deptid,
                START_DATE: startDate,
                END_DATE: endDate
            };
            this.cusmentCountDatas = []
            common.procedureQuery(params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                    if (res.data.length > 0) {
                        if (res.data[0].LABEL_NAME) {
                            this.cusmentCountDatas = res.data;
                        } else {
                            this.cusmentCountDatas = this.cutTop(res.data);
                        }
                    }
                } else {
                    this.cusmentCountDatas = []
                }
            })
        },


        // 格式化图表数据
        formatD2DData(arr) {
            // { name: '收费系统', value: 93 },
            let temarr = [];
            arr.map((item, index) => {
                let temObj = {}
                if (index > 4) return
                temObj.name = this.wrappingText(item.DEPT_NAME + ' ' + item.TOP_COUNT + '次');
                temObj.value = item.TOP_COUNT;
                temarr.push(temObj)
            })
            return temarr
        },
        // 超过4个文字换行
        wrappingText(str) {
            if (str.length > 4) {
                return str.substring(0, 5) + '\n' + str.substring(5)
            } else {
                return str
            }
        },
        // 创建图表
        createD2DData(formatdata) {
            // console.log(formatdata)
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} KM"
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    top: 40,
                    itemWidth: 70,
                    itemHeight: 30,
                    formatter: '{name}',
                    textStyle: {
                        color: '#FFFFFF'
                    },
                    data: []
                },
                calculable: true,
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '55%'],
                        center: ['50%', '50%'],//饼图的位置
                        label: {            //饼图图形上的文本标签
                            normal: {
                                show: true,
                                position: 'inner', //标签的位置
                                textStyle: {
                                    fontWeight: 300,
                                    fontSize: 16    //文字的字体大小
                                },
                                formatter: '{d}%'
                            }
                        },
                        // data:[{value:50,name:'高速50KM',itemStyle:{normal:{color:'#FE0000'}}}],
                        data: formatdata
                    }
                ]
            };
            return option
        },
        // 计算总预约量
        caleCount(arr) {
            let total = 0;
            if (Array.isArray(arr) && arr.length > 0) {
                arr.map((item) => {
                    total += item.TOP_COUNT
                })
            }
            return total
        },
        // 计算总预约量
        caleTime(arr) {
            let total = 0;
            if (Array.isArray(arr) && arr.length > 0) {
                arr.map((item) => {
                    total += item.TOP_TIME
                })
            }
            return total
        },

        // 切换年份
        changeMenu(value) {
            // 0 本年 1 本月 2 本周
            this.countMenuVal = value;
            this.startDate = this.calcStartEndDate(this.countMenuVal, 's');
            this.endDate = this.calcStartEndDate(this.countMenuVal, 'e');

            // this.$toast(this.startDate)

            const {getP2PSinge, getP2DSinge, getTotalqty, getPersonCount, getPersonTime, getDeptCount, getDeptTime, getP2P, getP2D, getD2D, getProductLine, getSegment, getCusment} = this;


            if (this.isShowUser) {
                getP2PSinge()
                getP2DSinge()
            } else {
                getP2P()
                getP2D()
            }

            if (this.isFAE) {
                getTotalqty()
                getPersonCount()
                getPersonTime()
            }

            if (this.isM || this.isBoss) {
                getTotalqty()
                getPersonCount()
                getPersonTime()
                getDeptCount()
                getDeptTime()
                getD2D()
                getProductLine()
                getSegment()
                getCusment()
            }
        },

        // 切换部门
        changeDept(data) {
            this.countDeptVal = data.id;
            this.deptId = data.id;
            this.userdept = data.name;

            this.isShowUser = false;

            const {getTotalqty, getPersonCount, getPersonTime, getDeptCount, getDeptTime, getP2P, getP2D, getD2D, getProductLine, getSegment, getCusment} = this;

            if (this.isFAE) {
                getTotalqty()
                getPersonCount()
                getPersonTime()
                getP2P()
                getP2D()
                return
            }

            if (this.isM || this.isBoss) {
                getTotalqty()
                getPersonCount()
                getPersonTime()
                getDeptCount()
                getDeptTime()
                getP2P()
                getP2D()
                getD2D()
                getProductLine()
                getSegment()
                getCusment()
                return
            }
        },

        // 切换用户
        changeUserMenu(value) {
            // console.log(value)

            const {getP2PSinge, getP2DSinge, getTotalqty, getPersonCount, getPersonTime, getDeptCount, getDeptTime, getP2P, getP2D, getD2D, getProductLine, getSegment, getCusment} = this;
            if (value) {
                this.isShowUser = true;
                this.userid = value;
                getP2PSinge()
                getP2DSinge()
                return

            } else {
                this.isShowUser = false;
                getTotalqty()
                getPersonCount()
                getPersonTime()
                getDeptCount()
                getDeptTime()
                getP2P()
                getP2D()
                getD2D()
                getProductLine()
                getSegment()
                getCusment()
                return
            }


        },

        //
        changeP2PMenu(value) {
            // console.log(value)
            this.p2pIndex = value
        },


        onAllCharts() {

        }
    }
}
